import { useEffect, useState } from 'react';

const REDUCE_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Reactive `prefers-reduced-motion: reduce`. SSR-safe: starts `false`
 * (no-preference) and resolves on the client after mount; re-evaluates on the
 * matchMedia `change` event so toggling the OS/browser setting updates live.
 */
export const usePrefersReducedMotion = (): boolean => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mql = window.matchMedia(REDUCE_MOTION_QUERY);
    const update = () => setPrefersReducedMotion(mql.matches);

    update();
    mql.addEventListener?.('change', update);

    return () => {
      mql.removeEventListener?.('change', update);
    };
  }, []);

  return prefersReducedMotion;
};
